import { Directive, ElementRef, HostListener, Input, OnInit, EventEmitter, Output, Renderer2 } from '@angular/core';
import { LinkService } from '../services/link.service';
import { LinkElement } from '../models/link-element.model';
import { LinkGroup } from '../models/link-group.model';
import { removeElement } from '../helpers/element-utils.helper';
import { drawCirclePlaceHolder } from '../helpers/elements-svg.helper';

@Directive({
  selector: '[rteLinkElements]'
})
export class LinkElementsDirective implements OnInit {
  
  //#region Inputs

  @Input('rteLinkDisabled') disabled : boolean;
  @Input('rteLinkElements') groupName : string;
  @Input('rteLinkEnable') linkEnable : boolean = true;
  @Input('rteLinkData') linkData : any;

  //#endregion

  //#region Outputs

  @Output('rteAfterLink') afterRegisterLink = new EventEmitter<any>();

  //#endregion

  group : LinkGroup;
  linkElm : LinkElement;

  constructor(private elm: ElementRef, 
    private linkService : LinkService, 
    private renderer : Renderer2) { }

  //#region Interface Implementations

  ngOnInit(){
    if(this.groupName){
      this.group = this.linkService.getGroupByName(this.groupName);
      
      this.linkElm = this.linkService.registerVirtualLinkElement(this.getLinkElement(), this.group);
    }
  }

  //#endregion

  //#region Events

  @HostListener('click',['$event']) onClick(event) {
    if(this.elementIsAvalable() && !this.disabled){
      this.registerLink(event);
    }
  }

  //#endregion

  drawTemporatyCircle(event){
    let link = this.getLinkElement(event);
    this.linkElm.temporaryCircle = drawCirclePlaceHolder(this.linkElm.temporaryCircle,link,this.group, this.linkService.aditionFactor);
  }

  removeTemporatyCircle(event){
    removeElement(this.linkElm.temporaryCircle);
    this.linkElm.temporaryCircle = null;
  }

  registerLink(event){
    let link = this.getLinkElement(event);
    this.linkService.registerLink(link,this.group);
  }

  getLinkElement(event = null) : LinkElement{
    if(this.linkElm != null){
      this.linkElm.event = event;
      return this.linkElm;
    }
    else {
      return {
        data : this.linkData,
        element : this.elm.nativeElement,
        event : event
      } 
    }
  }

  elementIsAvalable(): boolean{
    return this.linkEnable && this.group != null && !this.disabled;
  } 
}
